/**
 * street.js
 * 4. KỊCH TÍNH & HÀNH ĐỘNG ĐƯỜNG PHỐ
 */

export const STREET_POSES = {
  argue: (pose, time) => {
    // Cãi nhau gay gắt: vung tay, chém tay, chỉ trỏ xỉa xói, thân người chồm tới trước
    const argCycle = time * 8.0;
    pose.torsoRotX = 0.18 + Math.sin(argCycle * 0.5) * 0.08;
    pose.torsoRotY = Math.sin(argCycle * 0.7) * 0.15;
    pose.headRotX = -0.1 + Math.sin(argCycle) * 0.08;
    pose.headRotY = Math.sin(argCycle * 0.8) * 0.12;

    // Tay phải chỉ trỏ quyết liệt
    pose.rightArmRotX = -Math.PI * 0.5 + Math.sin(argCycle) * 0.35;
    pose.rightArmRotZ = 0.12;
    pose.rightForearmRotX = -0.45 + Math.sin(argCycle * 1.2) * 0.25;

    // Tay trái vung vẩy chém gió
    pose.leftArmRotX = -0.4 - Math.cos(argCycle) * 0.3;
    pose.leftArmRotZ = -0.35;
    pose.leftForearmRotX = -0.35;

    pose.rootY = Math.abs(Math.sin(argCycle * 0.5)) * 0.02;
  },

  punch: (pose, _time, elapsed) => {
    // Cú đấm võ thuật thẳng dứt khoát (One-shot: Lấy đà -> Phóng thẳng bộc phá -> Thu tay)
    const t = Math.min(elapsed, 0.9);
    if (t < 0.2) {
      // Lấy đà: Kéo tay phải ra sau, xoay hông
      const p = t / 0.2;
      pose.torsoRotY = -p * 0.35;
      pose.torsoRotX = p * 0.1;
      pose.rightArmRotX = -0.3 * p;
      pose.rightArmRotZ = 0.2 * p;
      pose.rightForearmRotX = -1.55 * p; // Co cùi chỏ nén lực
      pose.leftArmRotX = -0.85 * p; // Tay trái giơ lên che ngực phòng thủ
      pose.leftForearmRotX = -1.2 * p;
      pose.leftArmRotZ = -0.2;
    } else if (t < 0.45) {
      // Xuất quyền cực mạnh: Tay phải phóng thẳng, xoay hông dồn trọng tâm
      const p = (t - 0.2) / 0.25;
      pose.torsoRotY = -0.35 + p * 0.7; // Xoay hông từ -0.35 sang +0.35
      pose.torsoRotX = 0.15 + p * 0.12; // Chúi người theo cú đấm
      pose.rightArmRotX = -Math.PI * 0.52; // Cánh tay vung ngang tầm mặt
      pose.rightForearmRotX = -1.55 * (1 - p); // Cùi chỏ duỗi thẳng
      pose.rightArmRotZ = 0.05;
      pose.leftArmRotX = -0.9;
      pose.leftForearmRotX = -1.35;
      pose.leftArmRotZ = -0.25;
      pose.rootY = -0.04 * p;
    } else {
      // Thu tay về thế thủ
      const p = (t - 0.45) / 0.45;
      pose.torsoRotY = 0.35 * (1 - p);
      pose.torsoRotX = 0.27 * (1 - p);
      pose.rightArmRotX = -Math.PI * 0.52 * (1 - p * 0.6);
      pose.rightForearmRotX = -0.55 * p;
      pose.leftArmRotX = -0.9 * (1 - p * 0.7);
      pose.leftForearmRotX = -1.35 * (1 - p * 0.7);
    }
  },

  dodge: (pose, _time, elapsed) => {
    // Né đòn (One-shot hoặc Loop phản xạ): Nghiêng lách người sang một bên, thụp đầu nhẹ
    const t = Math.min(elapsed, 1.0);
    const p = Math.sin(t * Math.PI);
    pose.torsoRotZ = p * 0.45; // Nghiêng thân người lách sang bên
    pose.torsoRotX = p * 0.2; // Hơi cúi người tránh đòn
    pose.headRotZ = -p * 0.3;
    pose.rootY = -p * 0.08; // Khụy gối nhẹ
    // Hai tay đưa lên đỡ thủ
    pose.leftArmRotX = -p * 0.85;
    pose.leftForearmRotX = -p * 1.15;
    pose.rightArmRotX = -p * 0.7;
    pose.rightForearmRotX = -p * 1.05;
  },

  taunt: (pose, time) => {
    // Phủi tay, thong thả đắc thắng
    const tCycle = time * 4.5;
    pose.torsoRotX = -0.05;
    pose.headRotY = Math.sin(tCycle * 0.5) * 0.15;
    // Tay phải phủi nhẹ vào tay trái
    pose.leftArmRotX = -0.65;
    pose.leftForearmRotX = -0.85;
    pose.rightArmRotX = -0.75 + Math.sin(tCycle) * 0.25;
    pose.rightForearmRotX = -0.95 + Math.sin(tCycle) * 0.35;
    pose.rightArmRotZ = -0.2;
  },

  check_phone: (pose, time) => {
    // Cúi đầu quẹt điện thoại chờ đơn hàng / tin nhắn
    const tBreath = time * 2.0;
    pose.rootY = Math.sin(tBreath) * 0.008;
    pose.torsoRotX = 0.06;
    pose.headRotX = 0.32; // Đầu cúi xuống màn hình
    pose.headRotY = 0.05;

    // Tay phải nâng điện thoại ngang ngực
    pose.rightArmRotX = -0.65;
    pose.rightArmRotZ = -0.25;
    pose.rightForearmRotX = -1.15;
    pose.rightForearmRotY = -0.3;

    // Tay trái đưa ngón sang chạm nhẹ màn hình
    pose.leftArmRotX = -0.55;
    pose.leftArmRotZ = 0.2;
    pose.leftForearmRotX = -1.05;
    pose.leftForearmRotY = 0.35 + Math.sin(time * 3.5) * 0.08;
  },

  traffic_direct: (pose, time) => {
    // Phân luồng giao thông: Tay trái giơ chặn xe, tay phải vung gậy/dùi cui điều tiết
    const tCycle = time * 3.8;
    pose.torsoRotX = 0.02;
    pose.headRotY = Math.sin(tCycle * 0.5) * 0.22; // Đầu xoay nhìn dòng xe

    // Chân đứng thế vững chãi
    pose.leftLegRotZ = -0.05;
    pose.rightLegRotZ = 0.05;

    // Tay trái giơ ngang dứt khoát ra hiệu dừng xe
    pose.leftArmRotZ = 1.35;
    pose.leftArmRotX = -0.15;
    pose.leftForearmRotX = -0.15;

    // Tay phải vung gậy nhịp nhàng mời xe lưu thông
    pose.rightArmRotX = -0.4 + Math.sin(tCycle) * 0.4;
    pose.rightArmRotZ = -0.45 + Math.cos(tCycle) * 0.2;
    pose.rightForearmRotX = -0.65 + Math.sin(tCycle) * 0.25;
  },

  hands_behind_back: (pose, time) => {
    // Chắp hai tay sau lưng, dáng điềm tĩnh uy nghi (cán bộ hưu trí / bác bảo vệ đi tuần)
    const tWalk = time * 1.5;
    pose.rootY = Math.sin(tWalk) * 0.006;
    pose.torsoRotX = -0.06; // Ưỡn ngực nhẹ
    pose.headRotX = -0.04;
    pose.headRotY = Math.sin(time * 0.7) * 0.12;

    // Hai tay kéo gọn ra sau lưng, hai khuỷu tay gập lại
    pose.leftArmRotX = 0.48;
    pose.leftArmRotZ = -0.22;
    pose.leftForearmRotX = 1.15;
    pose.leftForearmRotY = -0.45;

    pose.rightArmRotX = 0.48;
    pose.rightArmRotZ = 0.22;
    pose.rightForearmRotX = 1.15;
    pose.rightForearmRotY = 0.45;
  },

  sip_drink: (pose, time) => {
    // Nâng bình giữ nhiệt / cốc trà đá lên nhấp một ngụm rồi hạ xuống
    const sCycle = (time * 1.5) % (Math.PI * 2);
    const isUp = Math.sin(sCycle) > 0.1;

    if (isUp) {
      // Nâng ly lên uống, đầu hơi ngửa
      pose.headRotX = -0.18;
      pose.torsoRotX = -0.04;
      pose.rightArmRotX = -1.25;
      pose.rightArmRotZ = -0.22;
      pose.rightForearmRotX = -1.45;
    } else {
      // Hạ ly ngang bụng nghỉ ngơi
      pose.headRotX = 0.02;
      pose.torsoRotX = 0.02;
      pose.rightArmRotX = -0.55;
      pose.rightArmRotZ = -0.15;
      pose.rightForearmRotX = -0.85;
    }

    // Tay trái buông thõng tự nhiên
    pose.leftArmRotX = -0.08;
    pose.leftArmRotZ = 0.12;
  },

  carry_box: (pose, time) => {
    // Bê thùng hàng to phía trước bụng (Shipper giao hàng)
    const tSway = time * 2.5;
    pose.rootY = -0.02 + Math.sin(tSway) * 0.01;
    pose.torsoRotX = -0.09; // Ngả người ra sau giữ trọng tâm
    pose.headRotX = 0.14; // Hơi cúi nhìn mặt đường

    // Hai tay gập vuông góc 90 độ đỡ dưới đáy thùng
    pose.leftArmRotX = -0.85;
    pose.leftArmRotZ = 0.2;
    pose.leftForearmRotX = -1.35;
    pose.leftForearmRotY = 0.4;

    pose.rightArmRotX = -0.85;
    pose.rightArmRotZ = -0.2;
    pose.rightForearmRotX = -1.35;
    pose.rightForearmRotY = -0.4;
  }
};
